<template>
  <BreadCrumb v-if="showgrid" page="Beranda > Pendaftaran > Data Keputusan PSB > Data Hasil Keputusan PSB"></BreadCrumb>
  <div class="container-fluid content-area" v-if="showgrid">
    <div class="row">
      <div class="col-md-12">
        <h3 class="judul-seksi-sga">Data Hasil Keputusan PSB</h3>
      </div>
    </div>
    <div class="" style="padding-top: 20px;">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <div class="flex justify-end mb-4">
              <Button
                  type="button"
                  icon="pi pi-file-excel"
                  label="Export to Excel"
                  severity="success"
                  @click="exportToExcel"
              />
            </div>
            <DataTable v-model:filters="filters" :value="dataKeputusan" ref="dt" tableStyle="min-width: 50rem"
                       paginator :rows="10"
                       :rowsPerPageOptions="[5, 10, 20, 50]"
                       :first="0"
                       :loading="loading"
            >
              <template #header>
                <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                    </span>
                </div>
              </template>
              <template #empty> Data tidak ada. </template>
              <template #loading> Mengambil data. Mohon tunggu. </template>
              <Column field="no_formulir" header="No formulir" sortable></Column>
              <Column field="nama_anak" header="Nama Anak" filterMatchMode="startsWith" sortable>
              </Column>
              <Column field="tglwawancara" header="Tanggal rekomendasi" sortable style="width: 25%"></Column>
              <Column field="nama_ortu" header="Nama Orang Tua" sortable style="width: 25%"></Column>
              <Column field="rekomendasi" header="Rekomendasi" sortable style="width: 25%"></Column>
              <Column field="keputusan" header="Keputusan PSB" sortable style="width: 25%"></Column>
              <Column>
                <template #body="slotProps">
                  <a v-if="slotProps.data.rekomendasi !=null" href="#" @click="toggleGrid(slotProps.data)" class="fa-solid fa-eye"></a>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PageUpdateDataKeputusan :data="selectedFormulir" v-if="!showgrid"
                           @change-view="toogleviewshowgrid"></PageUpdateDataKeputusan>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import {FilterMatchMode} from "@primevue/core/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import PageUpdateDataKeputusan from "@/components/viewadmin/keputusanpsb/PageUpdateDataKeputusan";
import DashboardServices from "@/services/dashboard.services";
import * as XLSX from 'xlsx'; // Import SheetJS

export default {
  name: "ViewKeputusanPSB",
  components: {PageUpdateDataKeputusan, BreadCrumb,DataTable,Column,InputText,Button},
  data:()=>({
    loading: false,
    lazyParams: {},
    showgrid: true,
    response:'',
    message:'',
    success: false,
    dataKeputusan:[],
    selectedFormulir:[],
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      'no_formulir': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'nama_anak': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'nama_ortu': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'jadwal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'tanggal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
    },
  }),
  methods:{
    // Excel Export Logic
    exportToExcel() {
      // Data dari API berupa array biasa
      const dataToExport = this.dataKeputusan;

      if (!dataToExport || dataToExport.length === 0) {
        alert('Tidak ada data untuk diexport.');
        return;
      }

      // Mapping sesuai kolom yang ditampilkan di DataTable
      const excelData = dataToExport.map((item, index) => ({
        'No': index + 1,
        'No Formulir': item.no_formulir,
        'Nama Anak': item.nama_anak,
        'Tanggal Rekomendasi': item.tglwawancara,
        'Nama Orang Tua': item.nama_ortu,
        'Rekomendasi': item.rekomendasi,
        'Keputusan PSB': item.keputusan
      }));

      // Buat worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Atur lebar kolom
      worksheet['!cols'] = [
        { wch: 6 },
        { wch: 20 },
        { wch: 30 },
        { wch: 25 },
        { wch: 30 },
        { wch: 25 },
        { wch: 25 }
      ];

      // Buat workbook
      const workbook = XLSX.utils.book_new();

      // Tambahkan worksheet
      XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          'Keputusan PSB'
      );

      // Download
      XLSX.writeFile(
          workbook,
          'data_keputusan_psb.xlsx'
      );
    },
    toogleviewshowgrid(){
      this.showgrid = true;
    },
    toggleGrid(data){
      this.showgrid = !this.showgrid;
      this.selectedFormulir = data;
    },
    getDataSiapKeputusan(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataSiapKeputusan';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataKeputusan = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },
  mounted() {
    this.getDataSiapKeputusan();
  }
}
</script>

<style scoped>

</style>